/* eslint-disable import/no-anonymous-default-export */
import HttpService from './http.service';

/**
 * Interfaz para representar un mensaje en la conversación
 */
export interface ConversationMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

/**
 * Interfaz para la solicitud de mapeo de servicios
 */
export interface ServiceMappingRequest {
  conversation: ConversationMessage[];
}

/**
 * Interfaz para la respuesta de mapeo de servicios
 */
export interface ServiceMappingResponse {
  serviceDescription: string;
  categoryName: string;
  cityName: string | null;
  scheduledDateTime?: string;
}


class ServiceMappingService {
  async mapService(conversationId: string, conversation: ConversationMessage[]): Promise<ServiceMappingResponse> {
    try {
      const request: ServiceMappingRequest = { conversation };
      const response = await HttpService.post<ServiceMappingResponse>(
        `/api/AI/conversations/${conversationId}/map-service`,
        request
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

//export default new ServiceMappingService();
const serviceMappingService = new ServiceMappingService();
export default serviceMappingService;

